export default __webpack_public_path__ + "static/media/1.210c1bf7.png";